/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ distance: NonNullable<unknown> }} Delivery_Distance_KmInputs */

const en_delivery_distance_km = /** @type {(inputs: Delivery_Distance_KmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.distance} km`)
};

const es_delivery_distance_km = /** @type {(inputs: Delivery_Distance_KmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.distance} km`)
};

const fr_delivery_distance_km = /** @type {(inputs: Delivery_Distance_KmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.distance} km`)
};

const de_delivery_distance_km = /** @type {(inputs: Delivery_Distance_KmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.distance} km`)
};

const id_delivery_distance_km = /** @type {(inputs: Delivery_Distance_KmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.distance} km`)
};

/** @type {(inputs: Delivery_Distance_KmInputs) => LocalizedString} */
const ja_delivery_distance_km = en_delivery_distance_km;

/** @type {(inputs: Delivery_Distance_KmInputs) => LocalizedString} */
const zh_delivery_distance_km = en_delivery_distance_km;

/** @type {(inputs: Delivery_Distance_KmInputs) => LocalizedString} */
const ar_delivery_distance_km = en_delivery_distance_km;

/** @type {(inputs: Delivery_Distance_KmInputs) => LocalizedString} */
const it_delivery_distance_km = en_delivery_distance_km;

/** @type {(inputs: Delivery_Distance_KmInputs) => LocalizedString} */
const ru_delivery_distance_km = en_delivery_distance_km;

/** @type {(inputs: Delivery_Distance_KmInputs) => LocalizedString} */
const pt_delivery_distance_km = en_delivery_distance_km;

/** @type {(inputs: Delivery_Distance_KmInputs) => LocalizedString} */
const ko_delivery_distance_km = en_delivery_distance_km;

/**
* | output |
* | --- |
* | "{distance} km" |
*
* @param {Delivery_Distance_KmInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const delivery_distance_km = /** @type {((inputs: Delivery_Distance_KmInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delivery_Distance_KmInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_delivery_distance_km(inputs)
	if (locale === "es") return es_delivery_distance_km(inputs)
	if (locale === "fr") return fr_delivery_distance_km(inputs)
	if (locale === "de") return de_delivery_distance_km(inputs)
	if (locale === "ja") return ja_delivery_distance_km(inputs)
	if (locale === "zh") return zh_delivery_distance_km(inputs)
	if (locale === "ar") return ar_delivery_distance_km(inputs)
	if (locale === "id") return id_delivery_distance_km(inputs)
	if (locale === "it") return it_delivery_distance_km(inputs)
	if (locale === "ru") return ru_delivery_distance_km(inputs)
	if (locale === "pt") return pt_delivery_distance_km(inputs)
	return ko_delivery_distance_km(inputs)
});